<template>
  <div class="vx-row">
    <div class="vx-col md:w-1/1 w-full">
      <vs-input class="w-full mt-4" label="Título" v-model="data.title" name="title" autofocus />

      <vs-input class="w-full mt-4" label="Código do Vídeo do YouTube" v-model="data.url" name="url" placeholder="ex. XPQ2lQ4RZA" />

      <div class="vx-row">
        <div class="vx-col md:w-4/12 w-full">
          <vs-select v-model="data.status" name="status" label="Situação" class="w-full mt-4">
            <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item, index) in status" />
          </vs-select>
        </div>
        <div class="vx-col md:w-4/12 w-full">
          <vs-input
            class="w-full mt-4"
            label="Ordem"
            v-model="data.sort"
            name="sort"
            type="number"
            min="0"
            placeholder="Numérico começando de 0"
          />
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col md:w-6/12 w-full text-center">
          <vs-button class="mt-4" icon-pack="feather" icon="icon icon-file" @click="save">Salvar</vs-button>
        </div>
        <div class="vx-col md:w-6/12 w-full text-right">
          <vs-button class="mt-4" icon-pack="feather" color="danger" @click="$router.push('/videos')"
          >Cancelar
          </vs-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker'
import {ptBR} from 'vuejs-datepicker/dist/locale'

export default {
  components: {
    Datepicker
  },
  data() {
    return {
      ptBR,
      data: {
        title: null,
        url: null,
        status: 1,
        sort: '0',
      },
      status: [
        {
          text: 'Ativo',
          value: 1
        },
        {
          text: 'Inativo',
          value: 0
        }
      ]
    }
  },

  mounted() {
    this.load()
  },

  methods: {
    load() {
      if (parseInt(this.$route.params.id) > 0) {
        this.$api
        .get(`/api/v1/affiliate/video/${this.$route.params.id}`)
        .then((response) => {
          this.$vs.loading.close()
          this.data = response.data
        })
        .catch((error) => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Erro',
            text: error.response.data.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
      }
    },
    save() {
      this.$vs.loading()

      this.$api({
        method: this.$route.params.id ? 'PATCH' : 'POST',
        url: this.$route.params.id ? `/api/v1/affiliate/video/${this.$route.params.id}` : '/api/v1/affiliate/video',
        data: this.data
      })
      .then((response) => {
        this.$vs.loading.close()
        this.data = response.data

        this.$vs.notify({
          text: 'Salvo',
          color: 'success'
        })

        this.$router.push('/videos')
      })
      .catch((error) => {
        this.$vs.loading.close()
        this.$vs.notify({
          title: 'Erro',
          text: Object.values(error.response.data.errors).join('<br>'),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      })
    },
  }
}
</script>
